import { ENUM__redux_action } from '@/state/_base/ENUM__redux_action';
import { PayloadAction } from '@reduxjs/toolkit';
import { DTO__workspace_user } from '@shared/dto/+workspace/workspace_user/DTO__workspace_user';
import { STATE__workspace } from '../STATE__workspace';

export const local_workspace_user_upsert = (payload: DTO__workspace_user[]): PayloadAction<DTO__workspace_user[]> => ({
  type: ENUM__redux_action.WORKSPACE_USER_UPSERT,
  payload,
});

export const init_local_workspace_user_upsert = (state: STATE__workspace, action: PayloadAction<DTO__workspace_user[]>) => {
  if (action.payload.is_empty()) return;

  for (let workspace_user of action.payload) {
    let users_map = state.all_workspaces_users_map.get_or_create_map(workspace_user.workspace_id);

    users_map.set(workspace_user.user_id, workspace_user);

    //need check by workspace_id and user_id because guest can have undefined id
    if (state.current_workspace_user.workspace_id == workspace_user.workspace_id && state.current_workspace_user.user_id == workspace_user.user_id) {
      state.current_workspace_user = workspace_user;
    }
  }

  //refresh map to trigger re-render
  state.all_workspaces_users_map = new Map(state.all_workspaces_users_map);
};
